module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("© 1997, 2013, by Theodore P. Savas"), _c('br'), _c('br'), _vm._v("\nAll rights reserved. No part of this book may be reproduced or utilized in any form or by"), _c('br'), _vm._v("\nany means, electronic or mechanical, including photocopying and recording, or by any"), _c('br'), _vm._v("\ninformation storage and retrieval system, without permission in writing from the"), _c('br'), _vm._v("\npublisher.")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_c('i', [_vm._v("Silent Hunters: German U-Boat commanders of World War II")]), _vm._v(", Theodore P. Savas, ed."), _c('br'), _c('br'), _vm._v("\nOriginally published: Campbell, California (Savas Publishing, 1997)."), _c('br'), _c('br'), _vm._v("\nIncludes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Digital First Edition"), _c('br'), _c('br'), _vm._v("\neISBN-13: 978-1-940669-00-7")]), _vm._v(" "), _c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/sp.jpg"
    }
  }), _c('br'), _c('br'), _vm._v("\n989 Governor Drive, Suite 102"), _c('br'), _c('br'), _vm._v("\nEl Dorado Hills, CA 95762"), _c('br'), _c('br'), _vm._v("\n916-941-6896 (phone)"), _c('br'), _c('br'), _vm._v("\n916-941-6895 (fax)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cbebeee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0